import { render, staticRenderFns } from "./EventSeriesBadge.vue?vue&type=template&id=6f26fe30&scoped=true&"
import script from "./EventSeriesBadge.vue?vue&type=script&lang=js&"
export * from "./EventSeriesBadge.vue?vue&type=script&lang=js&"
import style0 from "./EventSeriesBadge.vue?vue&type=style&index=0&id=6f26fe30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f26fe30",
  null
  
)

export default component.exports